<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn

                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-container
                fill-height
                fluid
                grid-list-xl>
            <v-layout
                    justify-center
                    wrap>
                <v-flex
                        xs12
                        md12
                >
                    <v-flex xs12>
                        <v-card
                                class="pa-4"
                                flat
                        >
                            <v-toolbar
                                    dense
                            >
                                <v-text-field
                                        hide-details
                                        single-line
                                        label="Name"
                                        v-model="search.name"
                                ></v-text-field>

                                <v-btn
                                        @click="filter_results(search)"
                                        icon
                                        color="blue-grey darken-4">
                                    <v-icon>
                                        mdi-magnify
                                    </v-icon>
                                </v-btn>
                            </v-toolbar>
                        </v-card>
                    </v-flex>

                    <v-data-table
                            :headers="headers"
                            :items="customers"
                            :server-items-length="totalItems"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            hide-default-footer
                            sort-by="calories"
                            class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Customers</v-toolbar-title>
                                <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="blue-grey darken-4" dark class="mb-2" v-on="on">New Customer
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout wrap>
                                                    <v-flex xs12>
                                                        <v-text-field v-model="editedItem.name" label="Name"
                                                                      required
                                                                      :error-messages="checkName"
                                                                      @input="$v.editedItem.name.$touch()"
                                                                      @blur="$v.editedItem.name.$touch()"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <v-switch v-model="editedItem.is_vip"
                                                                  :label="'VIP:'+editedItem.is_vip"></v-switch>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <v-text-field
                                                              v-model="editedItem.credit.credit"
                                                              label="Credit"
                                                              type="number"
                                                            ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-menu
                                                                ref="menu1"
                                                                v-model="menu1"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                max-width="290px"
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        v-model="editedItem.credit.expire_on"
                                                                        label="Expires On"
                                                                        hint="MM/DD/YYYY format"
                                                                        persistent-hint
                                                                        prepend-icon="mdi-event"
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="editedItem.credit.expire_on"
                                                                           no-title @input="menu1 = false"></v-date-picker>
                                                        </v-menu>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn
                                    color="blue-grey darken-4"
                                    fab
                                    rounded
                                    text
                                    @click="editItem(item)"
                            >
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                            <v-btn
                                    class="mx-2"
                                    fab
                                    v-show="item.state === 1"
                                    rounded
                                    text
                                    color="blue-grey darken-4"
                                    @click="deleteItem(item)"
                            >
                                <v-icon>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                            <v-btn
                                    class="mx-2"
                                    fab
                                    v-show="item.state === 4"
                                    rounded
                                    text
                                    color="blue-grey darken-4"
                                    @click="change_state(item, 1)"
                            >
                                <v-icon>
                                    mdi-check
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>


<script>

    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email} from 'vuelidate/lib/validators'

    export default {
        mixins: [validationMixin],

        validations: {
            editedItem: {
                name: {
                    required,
                    maxLength: maxLength(200)
                }
            }
        },
        components: {},
        data() {
            return {
                headers: [
                    {
                        text: '#',
                        align: 'left',
                        sortable: false,
                        value: 'id',
                    },
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name',
                    },
                    {
                        text: 'Actions',
                        align: 'center',
                        sortable: false,
                        value: 'action',
                    }
                ],
                notification_type: 'success',
                notification_message: '',
                notification: false,
                dialog: false,
                customers: [],
                editedIndex: -1,
                editedItem: {
                    name: '',
                    is_vip: false,
                    credit: {
                        id:0,
                        credit:0,
                        expire_on:null,
                        date_formated:null
                    }
                },
                defaultItem: {
                    id: 0,
                    name: '',
                    is_vip: false,
                    credit: {
                        id:0,
                        credit:0,
                        expire_on:null,
                        date_formated:null
                    }
                },
                page: 1, //default load page
                pageCount: 0,
                itemsPerPage: 50, //items shown per page,
                totalItems: 0,
                products: [],
                search: {},
                search_url: '',
                menu1: false,
                dateFormatted: null,

            }
        },
        computed: {
            checkName() {
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) return errors;
                !this.$v.editedItem.name.maxLength && errors.push('.name must be at most 200 characters long');
                !this.$v.editedItem.name.required && errors.push('.name is required.');
                return errors;
            },
            formTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            page(val) {
                this.load_customers(val)
            },
        },
        created() {
            this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
            this.load_customers(this.page);
        },
        methods: {
            formatDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            load_customers(page_no) {

                let offset = ( page_no - 1) * this.itemsPerPage;
                let limit = this.itemsPerPage;
                this.customers = [];
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/customers/?limit=' + limit + '&offset=' + offset + this.search_url).then((response) => {
                    this.customers = response.data.results;
                    this.notification = false;
                    this.notification_message = '';
                    this.totalItems = parseInt((response.data.count / this.itemsPerPage));
                    this.pageCount = parseInt((response.data.count / this.itemsPerPage).toFixed(0));
                    console.log(this.pageCount);
                    console.log(this.totalItems);
                    if(this.totalItems === 0)
                    {
                        this.totalItems = response.data.count;
                    }
                    // if (this.products.length < 1) {
                    //     this.load_products();
                    // }
                    console.log("Customers");
                    console.log("test reload");
                    console.log(this.customers);
                    this.$forceUpdate();


                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            editItem(item) {
                if(item.credit.id === 0)
                {
                    item.credit.date_formated = this.formatDate(new Date().toISOString().substr(0, 10));
                }
                this.editedIndex = this.customers.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            change_state(item, state)
            {
                this.$http.patch(
                    this.$http.defaults.baseURL + '/admin/customers/' + item.id + '/', {
                        state:state
                    }).then((response) => {
                    console.log(response);
                    this.notification = true;
                    item.state = state;
                    this.notification_message = 'Successfully Changed State';

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_type = 'red darken-1';
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },

            deleteItem(item) {
                const index = this.customers.indexOf(item);
                if (confirm('Are you sure you want to delete this item, all order data relating to this customer will also be deleted?')) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/customers/' + item.id + '/', {
                            state:4
                        }).then((response) => {
                            console.log(response);
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.customers.splice(index, 1);

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }
                let cus_products = [];


                if (this.editedIndex > -1) {
                    let cus_id = this.editedItem.id;

                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/customers/' + this.editedItem.id + '/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        this.save_credit(this.editedItem, this.editedItem.credit);
                        Object.assign(this.customers[this.editedIndex], this.editedItem);
                        // this.save_fave_products(cus_products, false, cus_id);


                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });


                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/customers/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        this.save_credit(response.data, this.editedItem.credit);
                        let customer_id = response.data.id;
                        this.customers.push(response.data);
                        this.close();
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            save_credit(customer, credit)
            {
                let send_data = {
                    credit:credit.credit,
                    customer: customer.id,
                    expire_on: credit.expire_on
                };
                let set_credit = credit;
                if(credit.id > 0)
                {
                      this.$hpatch(
                          this.$http.defaults.baseURL + '/admin/credit/' +credit.id+'/',send_data).then((response) => {
                              if(typeof response.data !== 'undefined')
                          {

                          }
                      });
                } else {
                    this.$hpost(this.$http.defaults.baseURL + '/admin/credit/', send_data).then((response) => {
                        if(typeof response.data !== 'undefined')
                        {
                            console.log(response.data);
                            set_credit = response.data;
                        }
                    });
                }

                let cus = this.customers.find(o => o.id === customer.id);
                cus.credit = set_credit;
            },
            save_fave_products(data, reload, customer) {

                this.$http.post(
                    this.$http.defaults.baseURL + '/admin/customer-fave-products/', {
                        drinks: data,
                        customer: customer
                    }).then((response) => {
                    if (reload === true) {
                        this.load_customers(this.page);
                    }
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            load_products() {
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/products/?limit=1000').then((response) => {
                    this.products = response.data.results;
                    this.notification = false;
                    this.notification_message = '';

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            filter_results(search) {
                let search_url = '';
                for (let prop in search) {
                    // skip loop if the property is from prototype
                    if (!search.hasOwnProperty(prop)) continue;

                    // your code
                    search_url += '&' + prop + '=' + search[prop];
                }
                this.search_url = search_url;
                this.page = 1;
                this.load_customers(1);

            }
        },
    }
</script>
